import React from 'react'
import cx from 'classnames'

import s from './Loader.scss'

import Round from './Round/Round'


const Loader = ({ className, relative, color, isHidden }) => !Boolean(isHidden) && (
  <div className={cx(s.overlay, className, { [s.relative]: relative })}>
    <Round color={color} />
  </div>
)


export default React.memo(Loader)

